<template>
  <div
    class="promotion-card"
    @click.stop="handleToDetail(promotion)"
  >
    <div class="promotion-image-container">
      <img
        :src="promotion.coverPic"
        :alt="promotion.title"
        class="promotion-image"
        @error="handleImageError"
      >
      <div class="promotion-date">
        {{ formatDate(promotion.createdTime) }}
      </div>
    </div>
    <div class="promotion-content">
      <h3 class="promotion-title">
        {{ promotion.title }}
      </h3>
      <p class="promotion-desc">
        {{ promotion.description }}
      </p>
      <van-button
        v-if="promotion.link"
        type="primary"
        size="small"
        class="promotion-button"
      >
        了解更多
      </van-button>
    </div>
  </div>
</template>

<script lang="ts">
// import { Promotion } from '@/api/base'
import { PropType } from 'vue'
import { Promotion } from '@/api/promotion'
import { useRouter } from 'vue-router'
import { getUserLang } from '@/storage/user'
export default {
  props: {
    promotion: {
      type: Object as PropType<Promotion>,
      required: true
    }
  },
  setup () {
    const handleImageError = (event: Event) => {
      const target = event.target as HTMLImageElement
      // target.src = 'https://via.placeholder.com/800x400/0A1E3C/FFFFFF?text=Promotion+Image'
    }

    const formatDate = (dateString: string) => {
      const date = new Date(dateString)
      const lang = getUserLang()
      return date.toLocaleDateString(lang, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }

    const router = useRouter()
    const handleToDetail = (promotion: Promotion) => {
      router.push({
        path: '/promotion/detail',
        query: {
          id: promotion.id
        }
      })
    }
    return {
      handleImageError,
      formatDate,
      handleToDetail
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.promotion-card {
  border-radius: $border-radius-lg;
  overflow: hidden;
  background: $white;
  transition: transform $transition-normal, box-shadow $transition-normal;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(10, 30, 60, 0.15);
  }
}

.promotion-image-container {
  position: relative;
  height: 300px;
  overflow: hidden;
}

.promotion-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform $transition-normal;

  .promotion-card:hover & {
    transform: scale(1.05);
  }
}

.promotion-date {
  position: absolute;
  top: $spacing-md;
  right: $spacing-md;
  background: rgba($primary-blue, 0.8);
  color: $white;
  padding: $spacing-xs $spacing-sm;
  border-radius: $border-radius;
  font-size: $font-size-xs;
  font-weight: 500;
}

.promotion-content {
  padding: $spacing-lg;
}

.promotion-title {
  font-size: $font-size-lg;
  font-weight: 600;
  margin-bottom: $spacing-sm;
  color: $primary-blue;
}

.promotion-desc {
  color: $text-light;
  margin-bottom: $spacing-md;
  line-height: 1.6;
}

.promotion-button {
  background-color: $accent-gold;
  border: none;

  &:hover {
    background-color: darken($accent-gold, 10%);
  }
}

// 1080×1920 设备适配
@media (min-width: 1080px) and (min-height: 1920px) {
  .promotion-image-container {
    height: 400px;
  }

  .promotion-content {
    padding: $spacing-xl;
  }

  .promotion-title {
    font-size: $font-size-xl;
  }

  .promotion-desc {
    font-size: $font-size-md;
  }
}

// 平板设备
@media (max-width: $breakpoint-lg) {
  .promotion-image-container {
    height: 250px;
  }
}

// 移动端适配
@media (max-width: $breakpoint-md) {
  .promotion-image-container {
    height: 200px;
  }

  .promotion-content {
    padding: $spacing-md;
  }

  .promotion-title {
    font-size: $font-size-md;
  }

  .promotion-desc {
    font-size: $font-size-sm;
  }
}
</style>
